import MainHeader from '../../components/MainHeader'
import MainFooter from '../../components/MainFooter'
import CTAButton from '../../components/CTAButton'

import './Page404.css'
import './MPage404.css'

import construction_img from '../../assets/pictures/sectionimages/construction-oBG.webp'


export default function Page404() {

    return (
        <div className='mainCon' id='mainCon'>
            <MainHeader selectedsite={""} disableanimation={false} />

            <section className='sec_start' id='sec_start--page404'>

                <h1>Wir haben uns verirrt.</h1>
                <h2>ERROR 404 - Seite nicht gefunden</h2>
                <div className='infocontainer'>
                    <p>
                        Kehre entweder zur vorherigen Seite oder zur <a href="/">Startseite</a> zurück.<br />
                        Falls du Hilfe benötigst, kontaktiere uns über unseren Kontaktbereich<br />
                        oder alternativ per Mail an <a href="mailto:hey@tonetwork.de">hey@tonetwork.de</a>.<br />
                        Wir stehen dir gerne zur Seite 😉
                    </p>
                </div>
                <br />
                <CTAButton className='start_cta' title="Zur Startseite" href={'/'} darkcta={true} />

                <img src={construction_img} alt={"Baustelle mit Arbeiter und Kran"} className='construction_img' />

            </section>
            <MainFooter />
        </div>
    )
}